export const FREE_GROUP_LIMIT = 4;
export const FREE_GROUP_CHANNEL_LIMIT = 10;
export const PRO_GROUP_CHANNEL_LIMIT = 25;

export const getGroupLimit = (userHasPro: boolean): number =>
  userHasPro ? Number.POSITIVE_INFINITY : FREE_GROUP_LIMIT;

export const getChannelLimit = (userHasPro: boolean): number =>
  userHasPro ? PRO_GROUP_CHANNEL_LIMIT : FREE_GROUP_CHANNEL_LIMIT;
